import { Page } from '@connected/ui/features/layouts';
import { createFileRoute } from '@tanstack/react-router';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { Loading } from '@/components/loading';
import { useInverter } from '@/hooks/queries/use-inverters';

export const Route = createFileRoute(
    '/(auth)/projects/$projectVersionId/re-inspections/pv-inverters/$inverterId',
)({
    component: Layout,
    pendingComponent: PendingComponent,
});

function Layout() {
    const { t } = useTranslation('re-inspections');

    const params = Route.useParams();

    const { data } = useInverter({
        electricalProjectVersionId: params.projectVersionId,
        pvInverterId: params.inverterId,
    });

    const title = useMemo(() => {
        const identifier = data?.inverter?.Identifier || t('pv-inverter.unknownInverter');

        return identifier;
        // TODO: Add brand model and serial number to title
        // const brandModel = data?.inverter?.BrandModel || null;
        // const serialNumber = data?.inverter?.SerialNumber || null;

        // if (!brandModel && !serialNumber) {
        //     return identifier;
        // }
        // if (brandModel && !serialNumber) {
        //     return `${identifier} - ${brandModel}`;
        // }
        // if (!brandModel && serialNumber) {
        //     return `${identifier} - ${serialNumber}`;
        // }

        // return `${identifier} - ${brandModel} - ${serialNumber}`;
    }, [data?.inverter?.Identifier, t]);

    return (
        <Page>
            <Page.Header>
                <Page.Header.Bar>
                    <Page.Header.Back
                        to="/projects/$projectVersionId/re-inspections/pv-inverters"
                        params={{
                            projectVersionId: params.projectVersionId,
                        }}
                    />
                    <Page.Header.Title>
                        {title}
                    </Page.Header.Title>
                </Page.Header.Bar>
            </Page.Header>
            <Page.Outlet />
        </Page>
    );
}
function PendingComponent() {
    return <Loading action="Omvormer aan het laden" />;
}
